import React from 'react';
import PropTypes from 'prop-types';

const CloseIconDialog = ({callback, image}) => {
  return (
    <img
      src={image}
      alt="close"
      onClick={() => callback()}
      style={{
        position: 'absolute',
        right: 8,
        top: 8,
        cursor: 'pointer',
        width: 24,
        height: 24,
        zIndex: 1,
      }}
    />
  );
};

CloseIconDialog.propTypes = {
  callback: PropTypes.func,
  image: PropTypes.string,
};

export default CloseIconDialog;
